module.exports = __webpack_public_path__ + "media/images/emblems/Sennwald-coat_of_arms-bd6d8e0885157dc14d0b9e7c7740493a.svg";